import { Map as ImmutableMap } from 'immutable';
import { createAction } from 'redux-actions';

import { rootUiActions, rootUiTypes } from 'app-components/flux/root-ui';
import store from 'app-components/utils/redux-store';

export const HOW_WE_CALCULATE_MODAL = 'HOW_WE_CALCULATE_MODAL';

import type { HowWeCalculateModalProps } from './types';

export const howWeCalculateModalAction = createAction(
  rootUiActions.createDialog.toString(),
  (props: HowWeCalculateModalProps) =>
    rootUiTypes.mkRootUiData({
      type: HOW_WE_CALCULATE_MODAL,
      props: ImmutableMap({
        ...props,
        title: props?.title || 'Tax Rates',
        modalType: props?.modalType || 'drawer',
      }),
    }),
);

export const dispatchHowWeCalculateModal = (props: HowWeCalculateModalProps) =>
  store?.dispatch(howWeCalculateModalAction(props));

export default dispatchHowWeCalculateModal;
